import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { canAccessPurchasePlan, isDivideAccount, isLoggedIn } from "@/utils/auth";

interface AuthGuardProps {
  children: ReactNode;
}

/** 路由守卫：无登录缓存时跳转登录页 */
export default function AuthGuard({ children }: AuthGuardProps) {
  const location = useLocation();

  if (!isLoggedIn()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}

/** 已登录访问登录页时，跳转到物资首页 */
export function GuestGuard({ children }: AuthGuardProps) {
  if (isLoggedIn()) {
    return <Navigate to="/goods" replace />;
  }

  return <>{children}</>;
}

/** 仅 is_divide 账号可访问（代购订单等） */
export function DivideGuard({ children }: AuthGuardProps) {
  const location = useLocation();

  if (!isLoggedIn()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!isDivideAccount()) {
    return <Navigate to="/403" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}

/** 仅科室 is_limit_quota=true 时可访问（采购计划） */
export function LimitQuotaGuard({ children }: AuthGuardProps) {
  const location = useLocation();

  if (!isLoggedIn()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!canAccessPurchasePlan()) {
    return <Navigate to="/403" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
